import { ProdutoModel } from '@models/financeiro/produto.model';
import { MatriculaGestaoModel } from '@models/gestao/matricula-gestao.model';

export class CartModel {

  candidato?: MatriculaGestaoModel;
  venda?: CartItemModel[];
  cfcCnpj?: string;

  constructor(
    options: CartModel = {}
  )  {
    this.candidato = options.candidato || null;
    this.venda = options.venda || [];
    this.cfcCnpj = options.cfcCnpj || null;
  }
}

export class CartItemModel {
  idProduto?: number;
  produto?: ProdutoModel;
  quantidade?: number;
  valorVenda?: number;

  constructor(options: CartItemModel = {}) {
    this.idProduto = options.idProduto || null;
    this.produto = options.produto || null;
    this.quantidade = options.quantidade || null;
    this.valorVenda = options.valorVenda || null;
  }
}
